import { createSlice } from '@reduxjs/toolkit';
import { userApi } from '@/apis/userApi';
import { Wallet } from '@/types/user';

interface WalletInfo {
  mainBalance: number;
  bonusBalance: number;
  exposure: number;
  lockedAmount: number;
  withdrawableBalance: number;
  depositBalance: number;
  coinAmount: number;
}

const initialState: WalletInfo = {
  mainBalance: 0,
  bonusBalance: 0,
  exposure: 0,
  lockedAmount: 0,
  withdrawableBalance: 0,
  depositBalance: 0,
  coinAmount: 0,
};

const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    resetWallet: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addMatcher(userApi.endpoints.getUserWallets.matchFulfilled, (state, { payload }) => {
      const balance = {
        mainBalance: 0,
        bonusBalance: 0,
        exposure: 0,
        lockedAmount: 0,
        withdrawableBalance: 0,
        depositBalance: 0,
        coinAmount: 0,
      };

      Array.isArray(payload) &&
        payload?.forEach((w: Wallet) => {
          const type = w?.type ? w?.type?.toLowerCase() : '';
          if (type === 'main') {
            balance.mainBalance = Number(w.amount);
            balance.exposure = Number(w.exposureAmount);
            balance.lockedAmount = Number(w.lockedAmount);
            balance.withdrawableBalance = Number(w.withdrawableBalance);
            balance.depositBalance = Number(w.depositBalance);
            balance.coinAmount = Number(w.coinAmount);
          } else if (type === 'bonus') {
            balance.bonusBalance = Number(w.amount);
          }
        });

      return balance;
    });
  },
});

export const { resetWallet } = walletSlice.actions;
export default walletSlice.reducer;
